<template>
  <div>
    <ButtonGroup
      v-if="!isButtonHidden"
      class="absolute -right-20 top-1/2 -translate-y-1/2 -rotate-90"
    >
      <Button @click="isOpen = true" severity="help">
        <RiToolsLine /> Inertia DevTools
      </Button>
      <Button
        icon="ri-eye-off-line"
        severity="help"
        variant="outlined"
        @click="isButtonHidden = true"
        class="bg-white"
      >
        <RiEyeOffLine />
      </Button>
    </ButtonGroup>

    <BaseDialog
      v-model="isOpen"
      header="Inertia DevTools"
      class="w-full max-w-5xl"
    >
      <Tabs value="data">
        <TabList>
          <Tab value="data"> Data </Tab>
          <Tab value="form"> Form </Tab>
        </TabList>
        <TabPanels>
          <TabPanel value="data">
            <JsonEditorVue v-model="props" :mode="Mode.tree" read-only />
          </TabPanel>
          <TabPanel value="form">
            <div class="flex flex-col gap-4">
              <div class="flex gap-2">
                <InputText v-model="url" fluid />
                <Select v-model="method" :options="methods" class="w-40" />
              </div>
              <JsonEditorVue
                v-model="jsonText"
                :mode="Mode.text"
                :main-menu-bar="false"
              />
              <Button @click="sendData" fluid> Send </Button>
            </div>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </BaseDialog>
  </div>
</template>

<script setup lang="ts">
import BaseDialog from '@/components/BaseDialog.vue'
import { router, usePage } from '@inertiajs/vue3'
import { computed, ref } from 'vue'
import JsonEditorVue from 'json-editor-vue'
import { Mode } from 'vanilla-jsoneditor'
import RiEyeOffLine from '~icons/ri/eye-off-line'
import RiToolsLine from '~icons/ri/tools-line'

const page = usePage()

const props = computed(() => page.props)

const isButtonHidden = ref(false)
const isOpen = ref(false)

const url = ref('')
const method = ref('POST')
const methods = ref(['GET', 'POST', 'PUT', 'PATCH', 'DELETE'])
const jsonText = ref(JSON.stringify({ hello: 'world' }, null, 2))

const sendData = () => {
  router[method.value.toLowerCase()](url.value, JSON.parse(jsonText.value), {
    preserveState: true,
    preserveScroll: true,
  })
}
</script>

<style scoped>
json-viewer {
  /* Background, font and indentation */
  --background-color: #ffffff;
  --color: #1f2937;
  --font-family: Nimbus Mono PS, Courier New, monospace;
  --font-size: 1rem;
  --line-height: 1.2rem;
  --indent-size: 0.5em;
  --indentguide-size: 1px;
  --indentguide-style: solid;
  --indentguide-color: #e5e7eb;
  --indentguide-color-active: #d1d5db;
  --indentguide: var(--indentguide-size) var(--indentguide-style)
    var(--indentguide-color);
  --indentguide-active: var(--indentguide-size) var(--indentguide-style)
    var(--indentguide-color-active);
  --outline-color: #9ca3af;
  --outline-width: 0;
  --outline-style: dotted;

  /* Types colors */
  --string-color: #059669;
  --number-color: #9a3412;
  --boolean-color: #2563eb;
  --null-color: #7c3aed;
  --property-color: #0369a1;

  /* Collapsed node preview */
  --preview-color: #b45309;

  /* Search highlight color */
  --highlight-color: #dc2626;
}
</style>
